import {get} from 'lodash'

type Props = {
  error: any
}

export const ErrorMessage = ({error}: Props) => {
  const errorMessage =
    typeof error === 'string'
      ? error
      : get(error, 'response.data.errorMessage') || get(error, 'message') || 'Unknown error'
  return <div className="text-red-500">{errorMessage}</div>
}
